import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../api/apiclient";
import { CREATE_AI_AGENT } from "../../api/endpoints";

// Async thunk for logging in
export const getStatisticsAgents = createAsyncThunk(
  "/api/statisticinfo_agents/",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiGet(`${CREATE_AI_AGENT}${params}/`);
      if (response?.data.status === "success") {
        return response?.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

const StatisticsSlice = createSlice({
  name: "statisticinfo_agents",
  initialState: {
    statisticInfoLoading: false,
    statisticInfoError: {},
    statisticInfo: {}
  },
  reducers: {
    clearStatisticInfo: (state) => {
      state.statisticInfo = {};
      state.statisticInfoLoading = false;
      state.statisticInfoError = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStatisticsAgents.pending, (state) => {
        state.statisticInfoLoading = true;
        state.error = null;
      })
      .addCase(getStatisticsAgents.fulfilled, (state, action) => {
        state.statisticInfoLoading = false;
        state.statisticInfo =action.payload;
      })
      .addCase(getStatisticsAgents.rejected, (state, action) => {
        state.statisticInfoLoading = false;
        state.statisticInfoError = action.payload.statisticInfoError;
      });
  },
});

export const { clearStatisticInfo } = StatisticsSlice.actions;

export default StatisticsSlice.reducer;
